// extracted by mini-css-extract-plugin
module.exports = {"container":"resourceCircle_container__2OY7K","isPressed":"resourceCircle_isPressed__ojTcB"};